import { INVALID_PASSWORD_CONFIRM } from "@/constants/invalids";
import { validator } from "@/utils/validator";

export const resetPasswordSchema = validator.object().shape({
  email: validator.string().emptyToNull().max(60).autoTransformToHalfWidth().label("メールアドレス").required(),
  newPassword: validator.string().emptyToNull().strongPassword(undefined, 12).label("新しいパスワード").required(),
  confirmNewPassword: validator
    .string()
    .emptyToNull()
    .trim()
    .oneOf([validator.ref("newPassword")], INVALID_PASSWORD_CONFIRM)
    .label("新しいパスワード（確認用）")
    .required(),
});
